import { AxiosRequestConfig } from 'axios';
import moment from 'moment';
import { findCookieValue } from '../shared/util/utility';

const TransactionApiWrapper = (requests: any) => {
	return {
		queryKeys: {
			transactions: 'transactions',
		},
		getAllTransaction: (filter: any, config: AxiosRequestConfig = {}) => {
			const configToSend: AxiosRequestConfig = {
				headers: {
					'Request-Language': 'pl',
				},
				params: {
					limit: filter.limit,
					offset: filter.offset,
					type: filter.type,
					to: moment().format('YYYY-MM-DD'),
				},
				...config,
			};
			return requests.get(`transaction/by-date`, configToSend);
		},
		annotate: (body: { transactionId: number; customName: string }) => {
			return requests.post(`transaction/annotate`, body);
		},
		cashOutBestSlip: (body: any, params: any) => {
			return requests.post(`cashout/full/${params.slipId}`, body);
		},
		cashOutBestSlipPrepareLiveCountDown: (body: any, params: any) => {
			return requests.post(`cashout/prepare-live-countdown/${params.slipId}`, body);
		},
		checkMaximumCashout: (slipId: number) => {
			return requests.get(`cashout/max/${slipId}`);
		},
		hasPlacedBetWithin: (days: number) => {
			return requests.get(`transaction/has-customer-placed-bet`, { params: { days } });
		},
		slipsSettled: () => {
			const config: AxiosRequestConfig = {
				headers: {
					'x-odds-session': findCookieValue('x-odds-session'),
				},
				params: {
					limit: 10,
					offset: 0,
				},
			};
			return requests.get(`transaction/slips-settled-after-last-login`, config);
		},
		getNumOfInGameCouponCount: () => {
			return requests.get('transaction/number-active-betslips');
		},
	};
};

export default TransactionApiWrapper;
